import { IFuelOpsLossRow } from 'types/fuelOps.interface'

export const FUEL_WRITE_OFF_APPROVAL_THRESHOLD_GHS = 50000

export const formatGhs = (value: number): string =>
  'GH₵ ' + new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(value)

export const formatGhsCompact = (value: number): string =>
  value >= 1000000
    ? 'GH₵ ' + (value / 1000000).toFixed(2).replace(/0$/, '') + 'M'
    : formatGhs(value)

export const fuelLossCostGhs = (liters: number, wacPerLitre = 0): number =>
  Math.round(liters * wacPerLitre)

export const criticalLossBannerText = (loss: IFuelOpsLossRow): string => {
  const cost = loss.costGhs ?? 0
  return `${new Intl.NumberFormat('en-US').format(loss.liters)} L loss — ${formatGhs(cost)} · opened ${loss.dateLabel} · owner ${loss.owner}`
}

export const findOpenCriticalLoss = (rows: IFuelOpsLossRow[]): IFuelOpsLossRow | undefined =>
  rows.find((l) => l.severity === 'critical' && l.caseStatus === 'OPEN')

export const stockValuationLine = (wacPerLitre: number, lastDeliveryPrice: number | null): string =>
  `Stock valued at weighted average GH₵ ${wacPerLitre.toFixed(2)}/L${lastDeliveryPrice != null ? ` · last delivery GH₵ ${lastDeliveryPrice.toFixed(2)}/L` : ''}`

export const FUEL_UNVERIFIED_DELIVERY_NOTE =
  'Received before the delivery verification process was introduced.'

export const FUEL_DISPENSE_FOOTNOTE =
  'Captured by the task engine’s Fuel Added worker component — no duplicate entry.'

export const FUEL_RESIDUAL_EXPLAINER =
  'Batch-close residuals are auto-flagged: unaccounted remainder is never silently written off.'

export const FUEL_LOSS_CLOSURE_CAPTION =
  'A loss case is not finished until it is closed with an outcome. Write-offs above GH₵ 50,000 need GM sign-off.'

export const FUEL_SUPPLIER_FOOTNOTE = 'Price history per delivery lands with the procurement bridge.'

export const FUEL_CLAIMS_CAPTION = 'A claim nobody tracks is a discount we gave.'

export const FUEL_AUTHORIZED_DRAWERS_CAPTION =
  'Draws by anyone not on the list are flagged UNAUTHORIZED in the log above.'

export const FUEL_DRUM_FLOAT_SUMMARY_SUFFIX =
  ' custody in limbo until confirmed or returned.'

export const FUEL_DISPENSER_CAPTION =
  'Calibration register — overdue dispensers block sign-off on high-variance days.'

export const FUEL_THRESHOLD_FOOTNOTE =
  'Tolerance bands come from site fuel custody config.'

export const FUEL_COVER_THRESHOLD_TITLE = 'Days of cover at current burn rate'
